import React, { useState, useEffect,useContext } from "react";

// CSS file for custom styles
import "./Mid-section-Mobile.scss";

//import components
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";

//icons
import Card from "../../../Caretaker-Components/OverView/Mobile-and-Tablet/Card";
import RecentPaymentsCards from "./RecentPaymentsCards";
import PendingIncoicesCard from "./PendingIncoicesCard";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/custom-calender-icon.svg";
import { FaAngleDown } from "react-icons/fa6";
import TenantsList from "../../Tenants/Mobile-and-Tablet/TenantsList";
import TenantModificationModal from "./TenantModal.jsx";

//import context
import { MyContext } from "../../../../tenantsDashContext.jsx";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  fetchTenants,
  getProfile,
} from "../../../../redux/slices/sliceActions";

const MiddleSectionOverview = () => {
  const { curerntYear,currentMonth, monthNames,selectedDate,setSelectedDate } = useContext(MyContext);

  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile, tenants } = useSelector(
    (state) => state.landlordslice
  );
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [isLoading, setIsLoading] = useState(true);
  const [profileUpdated, setProfileUpdated] = useState(false);

  useEffect(() => {
    // dispatch(getProfile({ id, token, caretaker: true })).then((res) => {
    //   setProfileUpdated(true);
    //   console.log("profilic update", res);
    //   setIsLoading(false);
    // });

    if (
      selectedDate.month === currentMonth &&
      selectedDate.year === curerntYear
    ) {
      dispatch(getProfile({ id, token, caretaker: true })).then((res) => {
        setProfileUpdated(true);
        console.log("profile update", res);
        setIsLoading(false);
      });
    } else {
      const year = selectedDate.year;
      const month = selectedDate.month;

      const monthNumber = monthNames.indexOf(month) + 1;

      dispatch(
        getProfile({
          id,
          token,
          caretaker: true,
          time: {
            year: year,
            month: monthNumber,
          },
        })
      ).then((res) => {
        setProfileUpdated(true);
        console.log("profile with time update", res);
        setIsLoading(false);
      });
    }
  }, [selectedDate]);

  //modal state management
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const [tenantData, setTenantData] = useState({});

  const handleShowModal = (actionType) => {
    setAction(actionType);
    setShowModal(true);
  };

  //state management
  const [seeMoreClicked, setSeeMoreClicked] = useState(false);
  const [currentSelected, setCurrentSelected] = useState(0);

  return (
    <div className="mid-section-mobile-caretaker">
      <div className="title-date-and-property">
        <div className="title">Reports</div>
        <div className="date-and-property">
          <MonthYearPicker
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
          <div className="apartment">
            <select
              id="apartment-select"
              name="apartment"
              className="apartment-dropdown"
            >
              <option value="apartment1">Apartment 1</option>
              <option value="apartment2">Apartment 2</option>
              <option value="apartment3">Apartment 3</option>
            </select>
          </div>
        </div>
      </div>
      <div className="cards-slider">
        <Card setCurrentSelected={setCurrentSelected} />
      </div>
      {currentSelected === 0 && (
        <>
          <div className="recentPaymentsSection">
            <div className="title">Recent Payments</div>
            <div className="payment-list">
              <RecentPaymentsCards selectedDate={selectedDate} />
            </div>
          </div>
        </>
      )}
      {currentSelected === 1 && (
        <>
          <div className="recent-enlistings-section">
            <div className="title">Recent Enlistings</div>
            <div className="tenants-list">
              <TenantsList
                handleShowModal={handleShowModal}
                setTenantData={setTenantData}
              />
            </div>
          </div>
        </>
      )}

      {currentSelected === 2 && (
        <>
          <div className="recentPaymentsSection">
            <div className="title">Pending Invoices</div>
            <div className="payment-list">
              <PendingIncoicesCard selectedDate={selectedDate}/>
            </div>
          </div>
        </>
      )}

      {showModal && (
        <TenantModificationModal
          setShowPay={setShowModal}
          fieldToShow={action}
          tenantData={tenantData}
        />
      )}
    </div>
  );
};

export default MiddleSectionOverview;
